'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defaultExport = new String('table.table{color:#fff;width:100%;padding:0 15px;}.table th,.table td{text-align:left;padding:0.25em;}');

_defaultExport.__hash = '2114869170';
_defaultExport.__scoped = 'table.table.jsx-2036147187{color:#fff;width:100%;padding:0 15px;}.table.jsx-2036147187 th.jsx-2036147187,.table.jsx-2036147187 td.jsx-2036147187{text-align:left;padding:0.25em;}';
_defaultExport.__scopedHash = '2036147187';
exports.default = _defaultExport;